export const CLIENT_ID = '501159173795-848b45om332hpnf9bl3v4fpr05gfhpvp.apps.googleusercontent.com';
export const REDIRECT_URL = 'https://web.devhubcentral.com.br/auth';
